export default {
    1: "University of The Gambia",
    2: "Gambia College",
    3: "Management Development Institute",
    4: "UTG Master's",
};